"use client";
import { t as useImpressionRef } from "../chunks/use-impression-ref-k081rlv0dt8gci3d.js";
import { t as cn } from "../chunks/cn-dk9nmc4mhy1765ud.js";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/text/text.tsx
/**
* Typography component. Both typography and color are applied with Tailwind
* utility classes via `className` — there are no `variant`, `size`, or `color`
* props. Pick a step from the OD ramp (`text-{display,header,subheader,body,label}-{size}`)
* and a semantic color token (`text-od-content-*`).
*
* Use `as` to choose the rendered element (defaults to `<p>`); `as="label"`
* additionally accepts `htmlFor`. For truncation, add the `truncate` class
* (plus `min-w-0` inside flex/grid) via `className`.
*
* @example
* ```tsx
* <Text as="h1" className="text-header-lg">Page title</Text>
* <Text as="h2" className="text-subheader-md">Section</Text>
* <Text className="text-body-md">Default body copy</Text>
* <Text className="text-body-sm text-od-content-tertiary">Helper text</Text>
* <Text as="label" htmlFor="email" className="text-label-md">Form label</Text>
* <Text className="text-body-md truncate min-w-0">Clipped…</Text>
* ```
*/
function TextInner({ children, className, as, analyticsName, trackImpression, ...props }, ref) {
	return /* @__PURE__ */ jsx(as ?? "p", {
		ref: useImpressionRef(Boolean(analyticsName && trackImpression), analyticsName, "textViewEvent", ref),
		className: cn("m-0", className),
		...props,
		children
	});
}
/**
* Typography primitive for all text in the OD design language. Typography and
* color are applied with Tailwind utility classes via `className` — pick a step
* from the OD ramp (`text-{display,header,subheader,body,label}-{size}`) and a
* semantic color token (`text-od-content-*`).
*
* Use `as` to choose the rendered element (defaults to `<p>`); `as="label"`
* additionally accepts `htmlFor`. Set `analyticsName` (plus `trackImpression`)
* to emit a view event the first time it scrolls into view.
*
* @example
* ```tsx
* <Text as="h1" className="text-header-lg">Page title</Text>
* <Text className="text-body-md">Default body copy</Text>
* <Text className="text-body-sm text-od-content-tertiary">Helper text</Text>
* <Text as="label" htmlFor="email" className="text-label-md">Email</Text>
* ```
*/
var Text = forwardRef(TextInner);
//#endregion
export { Text };

